import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useSavedQuery } from './SavedQueryProvider'
import { formatQueryDate } from './utils'

const useStyles = makeStyles(() => ({
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '4px 12px',
    fontSize: '11px',
    color: 'var(--color-contrast-neutral-300)',
    borderTop: '1px solid var(--border-color)',
    backgroundColor: 'var(--surface-bg-color-d1)',
    whiteSpace: 'nowrap',
    minHeight: '24px'
  },
  separator: {
    width: '1px',
    height: '12px',
    backgroundColor: 'var(--border-color)'
  },
  label: {
    color: 'var(--color-contrast-neutral-300)'
  },
  value: {
    color: 'var(--font-color-main)'
  }
}))

function EditorFooter () {
  const classes = useStyles()
  const { currentQuery } = useSavedQuery()

  if (!currentQuery) {
    return (
      <div className={classes.footer}>
        <span className={classes.label}>Unsaved query</span>
      </div>
    )
  }

  return (
    <div className={classes.footer}>
      <span>
        <span className={classes.label}>Created: </span>
        <span className={classes.value}>{formatQueryDate(currentQuery.createdDate)}</span>
      </span>
      <div className={classes.separator} />
      <span>
        <span className={classes.label}>Last saved: </span>
        <span className={classes.value}>{formatQueryDate(currentQuery.modifiedDate)}</span>
      </span>
    </div>
  )
}

export default EditorFooter
